<lms-toolbar [options]="toolbarConfig">
  <div class="lms-toolbar__item" *lmsProfileGuard="'mars.messages.create'">
    <gl-button
      color-primary
      [text]="'nouns.misTitle' | translate"
      title="{{ 'nouns.misTitle' | translate }}"
      (onClick)="openSendMessageModal()"
    >
    </gl-button>
  </div>
</lms-toolbar>

<div class="gl-table__container">
  <gl-table
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="marsTutorizationMessagesTable"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
  >
  </gl-table>
</div>

<lms-modal #sendMessageModal size="small">
  <div class="gl-popup__close" (click)="sendMessageModal.close()">
    <span data-testid="sendMessageModal" class="glicon-close"></span>
  </div>
  <div class="gl-popup__title">
    {{ 'nouns.misTitle' | translate }}
  </div>
  <div class="gl-popup__text">
    <lms-dynamic-form [questions]="[messageTextArea]" (submit)="sendMessage($event)" [options]="{ disableCard: true }">
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="sendMessageModal.close()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
